import axios from 'axios'
import store from '@/store';
import router from '@/router'
import url from "./env"

// 创建一个axios的实例
const Axios = axios.create({
  baseURL: `https://${url.baseUrl}`, 
  timeout: 50000 * 2, // 请求超时时间
  // headers: {
  //   'Content-Type': 'application/json;charset=UTF-8',
  // }
})

// 添加请求拦截
Axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
Axios.interceptors.response.use(
  response => {
    // console.log('响应拦截器',response.data);
    if( response.data.code === 1 ) {
      console.log('token失效');
      router.push({ path: `/login` })
    }
    // 对响应数据做些什么
    return response
  },
  error => {
    console.log('响应拦截错误',error.message);
    
    // 对响应错误做些什么
    return Promise.reject(error)
  }
)

export default Axios